import Schema from 'AppReact/schema';
import { today } from 'AppReact';
import { property, group, makeReadyCard, makeReadyColumn } from 'types';

export default {
  cards: Schema(makeReadyCard, 'array', { defaultValue: [] }),
  status: Schema('string', 'primitive', { defaultValue: 'open' }),
  archived: Schema('string', 'array', { defaultValue: ['Active'] }),
  properties: Schema(property, 'array', { defaultValue: [] }),
  groups: Schema(group, 'array', { defaultValue: [] }),
  selectedPropertyIds: Schema('integer', 'array', { defaultValue: [] }),
  selectedGroupIds: Schema('integer', 'array', { defaultValue: [] }),
  view: Schema('string', 'primitive', { defaultValue: '' }),
  calendarSelectedDate: Schema('jsDate', 'primitive', { defaultValue: today() }),
  makeReadyCategories: Schema(makeReadyColumn, 'array', { defaultValue: [] }),
  selectedFloorplanIds: Schema('integer', 'array', { defaultValue: [] }),
  selectedTagIds: Schema('integer', 'array', { defaultValue: [] }),
  floorPlans: Schema({}, 'array', { defaultValue: [] }),
  noTagIds: Schema('integer', 'array', { defaultValue: [] }),
  startMoveOutDate: Schema('jsDate', 'primitive-nullable', { defaultValue: null }),
  startMoveInDate: Schema('jsDate', 'primitive-nullable', { defaultValue: null }),
  endMoveOutDate: Schema('jsDate', 'primitive-nullable', { defaultValue: null }),
  endMoveInDate: Schema('jsDate', 'primitive-nullable', { defaultValue: null }),
  cardCounts: Schema({}, 'object', { defaultValue: {} }),
  disabled: Schema('boolean', 'primitive', { defaultValue: false })
}